import styled from 'styled-components'

export const PasswordWrapper = styled.div.attrs({
  className: 'sm:block xs:flex xs:flex-col gap-1',
})``
